module.exports = __webpack_public_path__ + "static/media/GNB_01.1d41673b.svg";